import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LinkChainSvg = function LinkChainSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M15.616 2.249 22 8.633l-5.452 5.452-.959-.96 4.493-4.492-4.466-4.466-4.493 4.493-.959-.959z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m7.904 15.386 7.233-7.233.959.959-7.233 7.233z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "m8.411 11.372-4.493 4.493 4.466 4.466 4.493-4.493.959.959-5.452 5.452L2 15.865l5.452-5.452z"
    })]
  });
};
export var LinkChain = function LinkChain(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: LinkChainSvg
  }));
};